import { Config, ConfigData, ConfigResponse } from "@/api/types";
import axios from "axios";

export interface ConfigVoteResponse {
    upvotes: number;
    downvotes: number;
    score: number;
    my_vote: number;
}

export const getConfigStruct = () => axios.get<ConfigResponse>('/configs/struct');
export const getSelfConfig = () => axios.get<ConfigData>('/configs/me');
export const setKeyValue = (key: string, value: any) => axios.post('/configs/me/set', { key, value });
export const getConfigs = (filter: string, package_type?: string, sort?: string) =>
    axios.get<Config[]>('/configs', { params: { filter, package: package_type, sort } });
export const useConfig = (id: number) => axios.post(`/configs/${ id }/use`);
export const deleteConfig = (id: number) => axios.delete(`/configs/${ id }`);
export const voteConfig = (id: number, value: -1 | 0 | 1) =>
    axios.post<ConfigVoteResponse>(`/configs/${ id }/vote`, { value });
export const publishConfig = (type: string, name: string, description: string) =>
    axios.post('/configs/publish', { type, name, description })
